import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { BulkExternalTransactionsPanelComponent } from './lib/bulk-external-transactions-panel.component'
import { BulkExternalTransactionsKey } from './panel-key'

export const BulkExternalTransactionsPanelConfig: PanelConfig = {
  key: BulkExternalTransactionsKey,
  title: 'Bulk External Transactions',
  description:
    'Perform various actions on external transactions in bulk. Finding transactions across accounts, bulk posting and bulk exchanging.',
  category: PanelCategory.BULK_TOOLS,
  panelComponent: BulkExternalTransactionsPanelComponent,
  accessPermission: 'accessBulkExternalTransactionsPanel',
}
